
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as edocmQMpINTDKuZ1pm77DeG3Ae2LU9JM_WlGba4ZPtD4bAMeta } from "/var/www/2025-08-04_18_49/pages/edo.vue?macro=true";
import { default as help25PtkqvLYkdxmCOzuxBqiGJpr_45EpyI4Gryv43DWpBMEMeta } from "/var/www/2025-08-04_18_49/pages/help.vue?macro=true";
import { default as cargorAiePJuJLOB9iq2j6_45ZO_z61_45_45fRmvPa_wH0isBH23MMeta } from "/var/www/2025-08-04_18_49/pages/cargo.vue?macro=true";
import { default as indexGkAQtIsUz1eDKoashg5glXRGcuUkRTxM0KIIOoIwWDAMeta } from "/var/www/2025-08-04_18_49/pages/index.vue?macro=true";
import { default as _91slug_93XvrSmn1RqtbIMiRmwB9KW25QjApoFJ0d0i5VruwxkO0Meta } from "/var/www/2025-08-04_18_49/pages/[slug].vue?macro=true";
import { default as cookiergcdUeAyqz0JQZNmNIMFik2Ei_nenIM8LmfF_45NWt87EMeta } from "/var/www/2025-08-04_18_49/pages/cookie.vue?macro=true";
import { default as surveyvUCB4e_45hyIN2YLCJDnfRkrtKB235Ukm685ttXZ1SNPMMeta } from "/var/www/2025-08-04_18_49/pages/survey.vue?macro=true";
import { default as belarusdlwIQRJftmaKYaMO8YmGAa5erEGFG0t0xdBSsjycMioMeta } from "/var/www/2025-08-04_18_49/pages/belarus.vue?macro=true";
import { default as bonuses_45MxZhvO3GYRqBFhPOGoB0CHhJAOx_wtJcag2HpwNs6AMeta } from "/var/www/2025-08-04_18_49/pages/bonuses.vue?macro=true";
import { default as apiSiSrSkAmmvO3hFL1YlwVn4m6IAl3eY1kWkEIxE891FMMeta } from "/var/www/2025-08-04_18_49/pages/dev/api.vue?macro=true";
import { default as cms37GGmg_4566e8MvynE0RJVw08xKIyekhPEjTGiK2QynVgMeta } from "/var/www/2025-08-04_18_49/pages/dev/cms.vue?macro=true";
import { default as konkursxqgZtUsEcGdu6uf33X_xu_45g2toqNm2WaIyJJSHik2ysMeta } from "/var/www/2025-08-04_18_49/pages/konkurs.vue?macro=true";
import { default as successqQYIaWdP3p2B3L4BWMvFjIHvu2IzJ0XFb2t7xJT6HOAMeta } from "/var/www/2025-08-04_18_49/pages/success.vue?macro=true";
import { default as vacancyRVjjfN8fgkRnX9LQMKC70G3747NZK03vAlSfiXY6cAgMeta } from "/var/www/2025-08-04_18_49/pages/vacancy.vue?macro=true";
import { default as contactsst8Y7qFjfHAnSXcpiremfP2PFLu5p0_sIipk38pfYhUMeta } from "/var/www/2025-08-04_18_49/pages/contacts.vue?macro=true";
import { default as giveawaymwhBsiniJ7MGJiZRMsFQUMgTvt0qpoZSGsjT7Z7r2sQMeta } from "/var/www/2025-08-04_18_49/pages/giveaway.vue?macro=true";
import { default as guide_45lkZ8_45WBZU1MscVpSH2OzP6ad3znZpB5ryULM1EnoZVk2gMeta } from "/var/www/2025-08-04_18_49/pages/guide-lk.vue?macro=true";
import { default as servicesqGHrX16IRUZFDTpX7QZyqsKxPMYySOSXnZbgqewjuvUMeta } from "/var/www/2025-08-04_18_49/pages/services.vue?macro=true";
import { default as telegramOFUQeKKR8_45eH4IlsmaQL7fAQDspNhEhngD1d7nfOrR8Meta } from "/var/www/2025-08-04_18_49/pages/telegram.vue?macro=true";
import { default as documentsArPKVv6vXye2lm3hUbJAhD1OfAoAtm2eJnGphgZWYZ0Meta } from "/var/www/2025-08-04_18_49/pages/documents.vue?macro=true";
import { default as franchiseSwydxvs_IhtrcJTpTpvx5pHiM9zQEqRiiZikuRqoFI0Meta } from "/var/www/2025-08-04_18_49/pages/franchise.vue?macro=true";
import { default as insuranceGCe9pvVGog6TYtmj8f9tgH_45duuhXyNbrqZN8oVbpCTQMeta } from "/var/www/2025-08-04_18_49/pages/insurance.vue?macro=true";
import { default as kirghiziaaqKfZN2jF_nAt3Gf5u_45sYvAqfHeBHuoZA4XsjXMfecYMeta } from "/var/www/2025-08-04_18_49/pages/kirghizia.vue?macro=true";
import { default as mapSchemehYZdk6X8lxzlqvUGv53kmF_BTCP5_458ur6labkeegPIgMeta } from "/var/www/2025-08-04_18_49/pages/mapScheme.vue?macro=true";
import { default as _91id_93znxaJbEt4ST9HANVtNlspAm_uiqmXu50DuIQs6sQXzUMeta } from "/var/www/2025-08-04_18_49/pages/news/[id].vue?macro=true";
import { default as return_45sdHX7XuSbwFTXAaHE_45jmuFtMiX1pTdJaCVggN4vF6AFVEMeta } from "/var/www/2025-08-04_18_49/pages/return-sd.vue?macro=true";
import { default as smsClientLvToaL_45z5gyJnlBXav9C2g6Qwa4LvacNXJBCGfZTR5oMeta } from "/var/www/2025-08-04_18_49/pages/smsClient.vue?macro=true";
import { default as terminalsA8BhdP_45t4nD5frIB_0OvABslAkmwef2VAHchLpnvBd4Meta } from "/var/www/2025-08-04_18_49/pages/terminals.vue?macro=true";
import { default as iframeAUCHWMWzBgfN0HubrTpxg_52Cy_Q5_vu_45qeYSN8DJ0wMeta } from "/var/www/2025-08-04_18_49/pages/dev/iframe.vue?macro=true";
import { default as directionsbASuv_45H9mdfPqs84IBfavif4wn3E_4570h0gRpLUonp20Meta } from "/var/www/2025-08-04_18_49/pages/directions.vue?macro=true";
import { default as kazakhstanb_KrguE7OerkF4Zmh12rETQck3cOgQTGklBSxZ4r6NMMeta } from "/var/www/2025-08-04_18_49/pages/kazakhstan.vue?macro=true";
import { default as indexLv3sCJ1KmyUKyOeA0IhVol7WgXYfh_ni_UH9dH7AiL8Meta } from "/var/www/2025-08-04_18_49/pages/news/index.vue?macro=true";
import { default as svgTs2jHvVoQD_45AiKx1e2UNyZBDV8XgUmAlxgobvDUbZaoMeta } from "/var/www/2025-08-04_18_49/pages/ui-kit/svg.vue?macro=true";
import { default as vzpay_45failEByoSnWA7NL_457DXPqP8_KDKXJ4h0_m4CDgEFoai3zn0Meta } from "/var/www/2025-08-04_18_49/pages/vzpay-fail.vue?macro=true";
import { default as constructorTflEgArIEO0LlDGhGW9Ajdug5hz0X8I4tdAw38_454DJUMeta } from "/var/www/2025-08-04_18_49/pages/constructor.vue?macro=true";
import { default as indexJaD0_45OdXpQkc6U18fKh9dkB_45BzTEjM6A2cnASiTQXTAMeta } from "/var/www/2025-08-04_18_49/pages/gifts/index.vue?macro=true";
import { default as information1ssPdPL3JQQBO7vxDSXprM7s2k6vE6N4jipW1_45X26TQMeta } from "/var/www/2025-08-04_18_49/pages/information.vue?macro=true";
import { default as light2tKpvERUjujLC1BasQ_45Aklww3NE401k9VXgDAHudZTYMeta } from "/var/www/2025-08-04_18_49/pages/order/light.vue?macro=true";
import { default as claim_45filingCIc95iTcl5tmZyF9MNEI0R6qzw7oEzISpV9AX3N11mMMeta } from "/var/www/2025-08-04_18_49/pages/claim-filing.vue?macro=true";
import { default as _91type_930xtQljtbsMcT7zT9zMrfoth5_XPRpRksixUBY_tBsdgMeta } from "/var/www/2025-08-04_18_49/pages/gifts/[type].vue?macro=true";
import { default as marketplaceszGu7qpCgtNWja_45_450K4JLkXeZMOkdT4zubKl_X8A1wYoMeta } from "/var/www/2025-08-04_18_49/pages/marketplaces.vue?macro=true";
import { default as networkshopsgjM51ASHxASEWfvge_45MdYvuoOg_45_45r86WeghjwdmjZ6cMeta } from "/var/www/2025-08-04_18_49/pages/networkshops.vue?macro=true";
import { default as online_45storePtLi8OxoyyqIibPRpWs3DPVF1RvnsflBbzUHYCF8TXQMeta } from "/var/www/2025-08-04_18_49/pages/online-store.vue?macro=true";
import { default as manageUYxLqfIMLH_JOUfBMC3jB3x_sTqGFYa0bYArAOekikQMeta } from "/var/www/2025-08-04_18_49/pages/order/manage.vue?macro=true";
import { default as registrationvGfBS17k5wM6TZl_45YsZNYu8n8FMB7fpYTngsitfpVh0Meta } from "/var/www/2025-08-04_18_49/pages/registration.vue?macro=true";
import { default as safe_45custody_45_45Nuc9H8kxOvS5x_YvILn7rx7Z9z2pFzKeHIeGe94VYMeta } from "/var/www/2025-08-04_18_49/pages/safe-custody.vue?macro=true";
import { default as imageZSZ8T1sbSSrLNTYUHtjBPokyXjbTwJ5BSWCV3bCq7JQMeta } from "/var/www/2025-08-04_18_49/pages/ui-kit/image.vue?macro=true";
import { default as index_sawk5qWPlNOZoYjzElt341_QT2VXN_cap6jQ4cB7b0Meta } from "/var/www/2025-08-04_18_49/pages/ui-kit/index.vue?macro=true";
import { default as bag4Fzy_L0wxYfkcaKppGMMoC7gXMY0SxYOGesoFBrVuCsMeta } from "/var/www/2025-08-04_18_49/pages/wrapping/bag.vue?macro=true";
import { default as boxFxvagsHTXQB4WN2iAWpOJ_Rcwp4KXgYAYQKL1kqhh7AMeta } from "/var/www/2025-08-04_18_49/pages/wrapping/box.vue?macro=true";
import { default as cargo_45loadingd2Yd68SS6sN_4531CAtQWuvALTxyaXyXcPsChRa6V8kgoMeta } from "/var/www/2025-08-04_18_49/pages/cargo-loading.vue?macro=true";
import { default as happybirthdayJXd_1peOOcPc9MDERpkQunlRoIcWtAymFyAMb8Bx7OQMeta } from "/var/www/2025-08-04_18_49/pages/happybirthday.vue?macro=true";
import { default as managetZyEyBEF_45ZiwtRek0y2R_0d33BO_Eg76eMkQg2R6_fAMeta } from "/var/www/2025-08-04_18_49/pages/iframe/manage.vue?macro=true";
import { default as auth9DYhjY6mHUXFx2kqAkeRYDePwsgTiUCtNPfkbGVnb74Meta } from "/var/www/2025-08-04_18_49/pages/personal/auth.vue?macro=true";
import { default as indexfy5yRs1wHfS4DJjnQ6bx_wRXechU_45vXwJeprN0c5AkIMeta } from "/var/www/2025-08-04_18_49/pages/tariffs/index.vue?macro=true";
import { default as publicaPLXslzegxf9pqsGOkswJsgBGkjnuxqrUSJB8GZgWt0Meta } from "/var/www/2025-08-04_18_49/pages/ui-kit/public.vue?macro=true";
import { default as already_45answerH87mU6rsfun6g_45RJKBjkoOYUFAQm8wjc8cs60KsxwwoMeta } from "/var/www/2025-08-04_18_49/pages/already-answer.vue?macro=true";
import { default as tariffsP4wgC4HlfwXXNuHwT1cjJvzAeH45ao3BngVVtrjHxVkMeta } from "/var/www/2025-08-04_18_49/pages/iframe/tariffs.vue?macro=true";
import { default as _91id_93ZXM6e47MVo_dl_rg39U1wd_45G7DrLiBQAXQYXuvXqoFYMeta } from "/var/www/2025-08-04_18_49/pages/order/pay/[id].vue?macro=true";
import { default as indexPBKTqUhw2jJLM7zQYSEN18Jp0P_iPYPDGpKTcYtGXB4Meta } from "/var/www/2025-08-04_18_49/pages/personal/index.vue?macro=true";
import { default as privacy_45policyo4YCTT9gpb6Poasr2uCho0Vb1fIXBmGrTz401eVT3gMMeta } from "/var/www/2025-08-04_18_49/pages/privacy-policy.vue?macro=true";
import { default as _91hash_93s0MsIq8hQzZw_45CsEvDSkguRqGPNTt3_453n5s6fgdahS4Meta } from "/var/www/2025-08-04_18_49/pages/welcome/[hash].vue?macro=true";
import { default as indexMNzvIj47Wf4Q5k66MO4_45sg_45hxuNthQfdZhsw7omPv7wMeta } from "/var/www/2025-08-04_18_49/pages/wrapping/index.vue?macro=true";
import { default as delivery_45russiayq5VR6L9PCwmnKlj_45hwgPllE3EWuiPeKJT_oPe8tG84Meta } from "/var/www/2025-08-04_18_49/pages/delivery-russia.vue?macro=true";
import { default as payment_45methodsiUmac4EWW6dL7tYBxZ8o5hwKzyC8YWNZD_2mOGSu4zEMeta } from "/var/www/2025-08-04_18_49/pages/payment-methods.vue?macro=true";
import { default as qr_45infoeq_DF4vE2Z8JUVJQLb6kpEMlwUYtAKLJanDqvhMSls4Meta } from "/var/www/2025-08-04_18_49/pages/payment/qr-info.vue?macro=true";
import { default as successacDH_454nvB_45lZ0FJzif5aPIlmfVg9MmnE_Eq_45Q1BLuNoMeta } from "/var/www/2025-08-04_18_49/pages/payment/success.vue?macro=true";
import { default as importIoEgEqUjOJh3dJ16J8qoKMQ_LVaRpvSGsIeohkwQRE8Meta } from "/var/www/2025-08-04_18_49/pages/personal/import.vue?macro=true";
import { default as logoutJ45kdziRFuwOs2H_EytKW9MW374TT4plU7boUMdq9rYMeta } from "/var/www/2025-08-04_18_49/pages/personal/logout.vue?macro=true";
import { default as address_45delivery3YYfxAGVim2ZuIdA_45X0x_u8bdLXzZUMGDuP1Uoc7gVcMeta } from "/var/www/2025-08-04_18_49/pages/address-delivery.vue?macro=true";
import { default as cash_45on_45deliveryb9fGtma38ynvoFIQJEu9FxCVhcxvNR1lJuVK03Czs2kMeta } from "/var/www/2025-08-04_18_49/pages/cash-on-delivery.vue?macro=true";
import { default as happynewyear20244tiVii0p4Vza_UPB3Te6A4a_45dSLKsZ3RPskuAHtF280Meta } from "/var/www/2025-08-04_18_49/pages/happynewyear2024.vue?macro=true";
import { default as ozon34wCH5aPOCGPxEl5eLMXaa_zsdcXz1s_45UgdCAFKZVHsMeta } from "/var/www/2025-08-04_18_49/pages/marketplace/ozon.vue?macro=true";
import { default as pay_45failBujEAUrKlepg46IbsepXbqQy8lwZEoIuSA2K7fHlK2YMeta } from "/var/www/2025-08-04_18_49/pages/payment/pay-fail.vue?macro=true";
import { default as account6hBGDuYUod0hKqFLEMpmWimn_45_6UPYmAVIO4aV8jlwsMeta } from "/var/www/2025-08-04_18_49/pages/personal/account.vue?macro=true";
import { default as prohibited_45goods_Tp2CDdor6E86uNDu7yOWbLbb_QjpwNZ8qP4pAtktCsMeta } from "/var/www/2025-08-04_18_49/pages/prohibited-goods.vue?macro=true";
import { default as survey_45completedwaqTOlVXN5FwWnbboBJQtdy_hOz3zxMRLXIr6gS2gW0Meta } from "/var/www/2025-08-04_18_49/pages/survey-completed.vue?macro=true";
import { default as directionjPn_45mtOKbR5gyI6W8o8If1LpijiTermYuAtUrboZFIIMeta } from "/var/www/2025-08-04_18_49/pages/ui-kit/direction.vue?macro=true";
import { default as free_45group_45pickupkrXs_45HkvfBD3qBIgX34zYIns6gMAAUivvGtjfpepywgMeta } from "/var/www/2025-08-04_18_49/pages/free-group-pickup.vue?macro=true";
import { default as free_45pickup_45cargowsNuXeRi6hvF_45pQbZ0P4_455gNSk6dciaeirGpQB91ZSwMeta } from "/var/www/2025-08-04_18_49/pages/free-pickup-cargo.vue?macro=true";
import { default as calculatorlOxoAWjoCazhjiQOjehQeUY1R5yRR2VQ6_QHF0pOTEwMeta } from "/var/www/2025-08-04_18_49/pages/iframe/calculator.vue?macro=true";
import { default as merch_45for_45bonusesZOtWDXUZU5n3dWprE2OLtiT_ibwh3Y2zIFKTuUojmEUMeta } from "/var/www/2025-08-04_18_49/pages/merch-for-bonuses.vue?macro=true";
import { default as _91id_93i35nrou4FjVNORZ3ko0446g70f0ruJsru_KNwWBWs_gMeta } from "/var/www/2025-08-04_18_49/pages/order/pay/qr/[id].vue?macro=true";
import { default as card_45infoQZc20x7NESfuowXGe5etdDi9OU89c7eOSvCI7AJPmbUMeta } from "/var/www/2025-08-04_18_49/pages/payment/card-info.vue?macro=true";
import { default as discountzslw_ALjsqNYaG1Uw6IxlQpz5Y__45hXXLLQFiEcLpmP0Meta } from "/var/www/2025-08-04_18_49/pages/personal/discount.vue?macro=true";
import { default as hard_45boxP9aigbJsbj7MEFYdhjZHp1NBi_45xYjQuIcrqdEPDif9MMeta } from "/var/www/2025-08-04_18_49/pages/wrapping/hard-box.vue?macro=true";
import { default as forwarding_45receiptYpshXII_6cvDKSWfrEo9yKLvwCT__qxuEwpZRNr9OecMeta } from "/var/www/2025-08-04_18_49/pages/forwarding-receipt.vue?macro=true";
import { default as mailClient10201917Z1rpNYOtV_45XPGyQEjHs3JSfV4gvPGvTeFDCP6pUGhP0Meta } from "/var/www/2025-08-04_18_49/pages/mailClient10201917.vue?macro=true";
import { default as mobile_45applicationmWSPF6zX9SM7KYJnlwmTtrIHazymYR19Id8NcWk_45U_45UMeta } from "/var/www/2025-08-04_18_49/pages/mobile-application.vue?macro=true";
import { default as indexnwBVvCGRsOT8miTMA52E1fd1chCYpyzv18El_xNuB68Meta } from "/var/www/2025-08-04_18_49/pages/order/create/index.vue?macro=true";
import { default as indexB86ItZajHHCTmn52LXpSxxgLFpZL4BsvGd5fREGc3AsMeta } from "/var/www/2025-08-04_18_49/pages/run-schedule/index.vue?macro=true";
import { default as boatH5WxLOqOivaRRiQrdLFCdjoqVCFA8JyHANV9eTLCxKkMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/boat.vue?macro=true";
import { default as sofaaFXkFqwDVtNt_Op95GxzscePpXgRMBYq17ypiTOqPjEMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/sofa.vue?macro=true";
import { default as _91location_93o7HHUVPoBDICVPtofsty0fsrY_45ioJ8_U7H3LxmIYT4EMeta } from "/var/www/2025-08-04_18_49/pages/tariffs/[location].vue?macro=true";
import { default as cardboardkkXyyi9Q2m1cJR7z9tE7UkG3eDEKjlNVWLlPVWLVFxYMeta } from "/var/www/2025-08-04_18_49/pages/wrapping/cardboard.vue?macro=true";
import { default as promocodesTy1wvXU72CFquGHox_45lb25jzf5GBOgu05mcPQLMAHvcMeta } from "/var/www/2025-08-04_18_49/pages/personal/promocodes.vue?macro=true";
import { default as benchh9_Nlc3rPciPR7daEOMZhdUckaf_45N07D165pAbcW_jAMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/bench.vue?macro=true";
import { default as booksMR0nKn6apZUVHukL2Hhm8V8DyGlVHHRgl0EGno8cWyEMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/books.vue?macro=true";
import { default as cablevAyc_45Nv0Z8h4W3ONCYV1w1t_z_7enDDDTPvSAx7cHvcMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/cable.vue?macro=true";
import { default as chairCEwfRrIaQHqTVE8kZtOYl9UoDB7brKMGdEqRBv1VMxEMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/chair.vue?macro=true";
import { default as goodsuSBOPADETBXbA2lYvwH3n5nk8mdv2fCaT5wGPtoE0uAMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/goods.vue?macro=true";
import { default as indexT2cEJSstSODo8ZUfEP4SG2AWMYB2O_nbcouW99tg_45QQMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/index.vue?macro=true";
import { default as metaloISwh_45r0FvptCth_Hi4TSFDYfwiu3wS0gN0MrGvIK9oMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/metal.vue?macro=true";
import { default as pianorcrjrrlUUQyypQnM1q58KOLIlcoXaXe9WjN0lncaCEYMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/piano.vue?macro=true";
import { default as pipes31MWE0I_gLjG_X4Z6pNRHthWCVQBe4jmCc_45mAp_fV0YMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/pipes.vue?macro=true";
import { default as toolsFCs8EpJLIXLGOn1ieLbgzVmVm9TchexbgNxvxG1l3ZIMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/tools.vue?macro=true";
import { default as pallet_45boxjEQ9pLAHlTx178fkWc3DlKodzcZczM7Dw3FtFo3_45o0oMeta } from "/var/www/2025-08-04_18_49/pages/wrapping/pallet-box.vue?macro=true";
import { default as _91tab_93PIWkw9T34NScKrOs3z0PhWVrkpCTa0gygsAczE7J1qAMeta } from "/var/www/2025-08-04_18_49/pages/personal/bonus/[tab].vue?macro=true";
import { default as printYUtv9ZM_x1zf3KMpNjQiDilxMjHMQP2r_Y1BF0NxqHQMeta } from "/var/www/2025-08-04_18_49/pages/personal/order/print.vue?macro=true";
import { default as dishes_45WMO_45icYmMQ6d60NyqJsZ9xs1XqbViQdr0HFKU4rcoMMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/dishes.vue?macro=true";
import { default as engine9EZ5OX_45Q6xrCixXuirXAtO_ke1ygin3YbPmFZ9xa7c0Meta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/engine.vue?macro=true";
import { default as lumberHQWvDPN4qrlkn8_45U1F0ENuYhFkrCsaKfJNky9SfecpQMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/lumber.vue?macro=true";
import { default as wheelssOjHK5CCYui8Mic2qSxf8xK_45YXCx8WSBVzqEjjI_45_45XUMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/wheels.vue?macro=true";
import { default as bubble_45filmpD3PKkulSDA48l0NJ6X2armAHmnNhBKQjXGPQ7aWc4AMeta } from "/var/www/2025-08-04_18_49/pages/wrapping/bubble-film.vue?macro=true";
import { default as palletisingoPg_45V5VBOzkXvRQ9Z5XGja5JLIum3ABMZZKw1giA9UsMeta } from "/var/www/2025-08-04_18_49/pages/wrapping/palletising.vue?macro=true";
import { default as fast_45delivery_45capitaljX6ox3duYAsCpb_H5lKP_45przcIZ7cN38tp0muh4C1HEMeta } from "/var/www/2025-08-04_18_49/pages/fast-delivery-capital.vue?macro=true";
import { default as _91guid_93z2u3XyVuUh066MUHOwU3EpLlXiCHVdoSdaxn6Pi0F_UMeta } from "/var/www/2025-08-04_18_49/pages/personal/order/[guid].vue?macro=true";
import { default as create0nfZLrij3IhGjRqk1QWSckwYz2G_45iuyZDqHRrQIIXA8Meta } from "/var/www/2025-08-04_18_49/pages/personal/order/create.vue?macro=true";
import { default as barrels40w_py2yIxOhvcYdEXczP8fqbr54kuGF2cmTu4IXBJ8Meta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/barrels.vue?macro=true";
import { default as clothes1kYQx9EBReOHPlsxDGPhJrL1GD1cZUsAedTAiYtMpe0Meta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/clothes.vue?macro=true";
import { default as fragileHdU1s5Twgyo3eMRemGcZqj0CH4kjzMqdLBPP15RnJ1EMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/fragile.vue?macro=true";
import { default as trailerI9qbCbvNUS08auaPQzpNrcY9FPnPdRMKPE7q1FY4po4Meta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/trailer.vue?macro=true";
import { default as safe_45packagey_45xiCJkbaRREPoc2gG5izDlFvmnmbxw1vZzE04GGlkwMeta } from "/var/www/2025-08-04_18_49/pages/wrapping/safe-package.vue?macro=true";
import { default as bepaid_45successcVJvy_yVxoYXVpFk_MmYWrem85U1HqT2Yqe_cUPwYjcMeta } from "/var/www/2025-08-04_18_49/pages/payment/bepaid-success.vue?macro=true";
import { default as extra_45package8EgzHNWIagdSSW7WbAl4ZEN75RqJXbqmxJCw5dKBTpIMeta } from "/var/www/2025-08-04_18_49/pages/wrapping/extra-package.vue?macro=true";
import { default as wildberriesgKy9_z9dhLcnAkqfKIBYzCAsDE8EgnbB6Cm3ccVnb0sMeta } from "/var/www/2025-08-04_18_49/pages/marketplace/wildberries.vue?macro=true";
import { default as _91guid_934sSipceLRcox7WgxfCtCZ7GNuIR2HzWe_45WKs_wcf_UQMeta } from "/var/www/2025-08-04_18_49/pages/order/administer/[guid].vue?macro=true";
import { default as _91location_937eimH_45cb6osQyRTJbopZeot2xVvYvaxZwrBhkcZzfu8Meta } from "/var/www/2025-08-04_18_49/pages/run-schedule/[location].vue?macro=true";
import { default as furnitureu7OE8UtCVcEaSXj_45qwBIM_45tO5OFd0Knq39GoD8oITp0Meta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/furniture.vue?macro=true";
import { default as oversizedCOA6xsBBYC0pFBVgVN9vK6gz6_bYVm8aY9r8qikqJN4Meta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/oversized.vue?macro=true";
import { default as quad_45bikeKAJ32IE3xHIAYM_45xAz6O4vNvlJ7Mdmvb7c34A1TshtEMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/quad-bike.vue?macro=true";
import { default as _91locations_93qJPS6ESscNyQENcwhwF49fJnlE6I1vblOXVdkdJeME8Meta } from "/var/www/2025-08-04_18_49/pages/order/create/[locations].vue?macro=true";
import { default as _91_46_46_46tab_93v1w_eU7fcdMrCs_45G66h5qE6QxBENVvBSPZDCZF1WP4cMeta } from "/var/www/2025-08-04_18_49/pages/personal/orders/[...tab].vue?macro=true";
import { default as auto_45partsO2cRiJM6Xul_45x207n4iGAL2YdhBCLkR7EAPM6trVbYoMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/auto-parts.vue?macro=true";
import { default as newspaperszbBIySKF_45rvmQcEejsv7skXsARbgi7u2DT6uW_450DLQoMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/newspapers.vue?macro=true";
import { default as smallcargo_45obc_h0x3YOkFcNVO3VaiWkMmBv3ZF8pi8I5yW7BVzwMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/smallcargo.vue?macro=true";
import { default as snowmobileZmuGlTtD3_cwFk_45HII3XVEaaPgOQ3vv6zQcpWH_45BsbMMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/snowmobile.vue?macro=true";
import { default as indextlFBoM1mAeV654hOXzjeWwt_45jZmwy9MLv8HoMOyIfewMeta } from "/var/www/2025-08-04_18_49/pages/iframe/order/create/index.vue?macro=true";
import { default as yandex_45marketqjJrxNz95VmIBO_455Bl5JnyVIb8NNqcZ7J4wSi9mHPhAMeta } from "/var/www/2025-08-04_18_49/pages/marketplace/yandex-market.vue?macro=true";
import { default as templatessM7VSRrhl_45H3Wbwh_Bx9mtguRxHRnszOneFsHnWrtbgMeta } from "/var/www/2025-08-04_18_49/pages/personal/orders/templates.vue?macro=true";
import { default as indexj1PgZIlM9x4gS_45APqjfYerLHexza80Jz0uQEbwKS2XoMeta } from "/var/www/2025-08-04_18_49/pages/personal/contractors/index.vue?macro=true";
import { default as refrigeratorLGTxZNE4N1sCNmhrfUQ62_45yG9_UN9I1vf1lifgCgf_QMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/refrigerator.vue?macro=true";
import { default as _91guid_93COI6M_wW_45YmDTc1Ca2PrrBfaa3FXirJaQnVPOA_45yjKYMeta } from "/var/www/2025-08-04_18_49/pages/personal/contractors/[guid].vue?macro=true";
import { default as indexaQd1XOawRHcVFm8iZL0RWDGPo1PPYY4zc6cIGYErxuUMeta } from "/var/www/2025-08-04_18_49/pages/personal/multi-pickup/index.vue?macro=true";
import { default as _91guid_93jAonfxUPYkxRCSagoRzng8WyYBwHMbHb5_45OXHD3SOH8Meta } from "/var/www/2025-08-04_18_49/pages/personal/multi-pickup/[guid].vue?macro=true";
import { default as consumer_45goods6qKV7oEP_XYFE5HVYRWtVvj6_45Wd6u4MFL0jo0NO_gT4Meta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/consumer-goods.vue?macro=true";
import { default as indexSLqq_aw_LjOHKpwn47g6wt1gnDi3uWpXjynShKHqXHMMeta } from "/var/www/2025-08-04_18_49/pages/personal/group-printing/index.vue?macro=true";
import { default as indexeDFuiv_GVlvuRQ9CQR8_EE2Bx_45WvYWkHWHjjlrGtQfsMeta } from "/var/www/2025-08-04_18_49/pages/personal/multi-delivery/index.vue?macro=true";
import { default as medical_45devices6nZaNt_45nSnIfMi9trvvhqWeK2MsGZHHHAbJ3m2fFbqAMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/medical-devices.vue?macro=true";
import { default as _91guid_932vUM7PTNTQ7o6agkywVLA5f_459RmSuDZYr8PLvzkeK5QMeta } from "/var/www/2025-08-04_18_49/pages/iframe/order/administer/[guid].vue?macro=true";
import { default as _91guid_93pEiX4dsoeZmw1UW5dSn4t7Qr7U_45EvV9k86yb13gFgFwMeta } from "/var/www/2025-08-04_18_49/pages/personal/multi-delivery/[guid].vue?macro=true";
import { default as _91_46_46_46id_93Fj0B0mh0RR1SbRpku_7VtuNjqMZygwOl3cbr0nf4VxIMeta } from "/var/www/2025-08-04_18_49/pages/personal/order/template/[...id].vue?macro=true";
import { default as special_45equipmentwso8L3oPXAuHEGWumqFiryu5E1D5frtKJ40Ij_45Sba7kMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/special-equipment.vue?macro=true";
import { default as building_45materials7FnVlM4BiWakCHTEpZSUjnSvFFgDKZ4xLrmDCRkuC9sMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/building-materials.vue?macro=true";
import { default as musical_45instrumentscZTw_45mzXaJtjyU5tJ5Qm7ch1zs6Iq2OPe_459GXqxgjdEMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/musical-instruments.vue?macro=true";
import { default as industrial_45equipmentL8rvaHGetX1VhYE0iM4ms1_rg_WicXWKBIANGvHe51MMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/industrial-equipment.vue?macro=true";
import { default as motorcycletransportation2E0fpZucOTPr21Xws1kETH34gK5bp6ekAIlKK9hmqSYMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/motorcycletransportation.vue?macro=true";
import { default as _91locationFrom_93__91locationTo_93ibBOon7CVqjQPZzbKI8lxnxLexYIiAwz0D4x4T_2eXMMeta } from "/var/www/2025-08-04_18_49/pages/order/create/[locationFrom]_[locationTo].vue?macro=true";
import { default as personalitemstransportation8c1QI4PcAPDtJguZpxQ0Srohlr9jHWVL2Dhj060Fb0wMeta } from "/var/www/2025-08-04_18_49/pages/shippingtypes/personalitemstransportation.vue?macro=true";
export default [
  {
    name: "edo",
    path: "/edo",
    component: () => import("/var/www/2025-08-04_18_49/pages/edo.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/var/www/2025-08-04_18_49/pages/help.vue")
  },
  {
    name: "cargo",
    path: "/cargo",
    component: () => import("/var/www/2025-08-04_18_49/pages/cargo.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/2025-08-04_18_49/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    meta: _91slug_93XvrSmn1RqtbIMiRmwB9KW25QjApoFJ0d0i5VruwxkO0Meta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/[slug].vue")
  },
  {
    name: "cookie",
    path: "/cookie",
    component: () => import("/var/www/2025-08-04_18_49/pages/cookie.vue")
  },
  {
    name: "survey",
    path: "/survey/:surveyId/",
    meta: surveyvUCB4e_45hyIN2YLCJDnfRkrtKB235Ukm685ttXZ1SNPMMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/survey.vue")
  },
  {
    name: "belarus",
    path: "/belarus",
    component: () => import("/var/www/2025-08-04_18_49/pages/belarus.vue")
  },
  {
    name: "bonuses",
    path: "/bonuses",
    component: () => import("/var/www/2025-08-04_18_49/pages/bonuses.vue")
  },
  {
    name: "dev-api",
    path: "/dev/api",
    component: () => import("/var/www/2025-08-04_18_49/pages/dev/api.vue")
  },
  {
    name: "dev-cms",
    path: "/dev/cms",
    component: () => import("/var/www/2025-08-04_18_49/pages/dev/cms.vue")
  },
  {
    name: "konkurs",
    path: "/konkurs",
    meta: konkursxqgZtUsEcGdu6uf33X_xu_45g2toqNm2WaIyJJSHik2ysMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/konkurs.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/var/www/2025-08-04_18_49/pages/success.vue")
  },
  {
    name: "vacancy",
    path: "/vacancy",
    component: () => import("/var/www/2025-08-04_18_49/pages/vacancy.vue")
  },
  {
    name: "contacts",
    path: "/:tag(address|contacts)/:location?",
    meta: contactsst8Y7qFjfHAnSXcpiremfP2PFLu5p0_sIipk38pfYhUMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/contacts.vue")
  },
  {
    name: "giveaway",
    path: "/giveaway",
    component: () => import("/var/www/2025-08-04_18_49/pages/giveaway.vue")
  },
  {
    name: "guide-lk",
    path: "/guide-lk",
    component: () => import("/var/www/2025-08-04_18_49/pages/guide-lk.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/var/www/2025-08-04_18_49/pages/services.vue")
  },
  {
    name: "telegram",
    path: "/telegram",
    component: () => import("/var/www/2025-08-04_18_49/pages/telegram.vue")
  },
  {
    name: "documents",
    path: "/documents",
    component: () => import("/var/www/2025-08-04_18_49/pages/documents.vue")
  },
  {
    name: "franchise",
    path: "/franchise",
    component: () => import("/var/www/2025-08-04_18_49/pages/franchise.vue")
  },
  {
    name: "insurance",
    path: "/insurance",
    component: () => import("/var/www/2025-08-04_18_49/pages/insurance.vue")
  },
  {
    name: "kirghizia",
    path: "/kirghizia",
    component: () => import("/var/www/2025-08-04_18_49/pages/kirghizia.vue")
  },
  {
    name: "mapScheme",
    path: "/mapScheme",
    meta: mapSchemehYZdk6X8lxzlqvUGv53kmF_BTCP5_458ur6labkeegPIgMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/mapScheme.vue")
  },
  {
    name: "news-id",
    path: "/:tag(news|actions)/:id",
    meta: _91id_93znxaJbEt4ST9HANVtNlspAm_uiqmXu50DuIQs6sQXzUMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/news/[id].vue")
  },
  {
    name: "return-sd",
    path: "/return-sd",
    component: () => import("/var/www/2025-08-04_18_49/pages/return-sd.vue")
  },
  {
    name: "smsClient",
    path: "/smsClient",
    component: () => import("/var/www/2025-08-04_18_49/pages/smsClient.vue")
  },
  {
    name: "terminals",
    path: "/terminals",
    component: () => import("/var/www/2025-08-04_18_49/pages/terminals.vue")
  },
  {
    name: "dev-iframe",
    path: "/dev/iframe",
    component: () => import("/var/www/2025-08-04_18_49/pages/dev/iframe.vue")
  },
  {
    name: "directions",
    path: "/directions",
    component: () => import("/var/www/2025-08-04_18_49/pages/directions.vue")
  },
  {
    name: "kazakhstan",
    path: "/kazakhstan",
    component: () => import("/var/www/2025-08-04_18_49/pages/kazakhstan.vue")
  },
  {
    name: "news",
    path: "/:tag(news|actions)",
    meta: indexLv3sCJ1KmyUKyOeA0IhVol7WgXYfh_ni_UH9dH7AiL8Meta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/news/index.vue")
  },
  {
    name: "ui-kit-svg",
    path: "/ui-kit/svg",
    component: () => import("/var/www/2025-08-04_18_49/pages/ui-kit/svg.vue")
  },
  {
    name: "vzpay-fail",
    path: "/vzpay-fail",
    component: () => import("/var/www/2025-08-04_18_49/pages/vzpay-fail.vue")
  },
  {
    name: "constructor",
    path: "/constructor",
    meta: constructorTflEgArIEO0LlDGhGW9Ajdug5hz0X8I4tdAw38_454DJUMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/constructor.vue")
  },
  {
    name: "gifts",
    path: "/gifts",
    meta: indexJaD0_45OdXpQkc6U18fKh9dkB_45BzTEjM6A2cnASiTQXTAMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/gifts/index.vue")
  },
  {
    name: "information",
    path: "/information",
    component: () => import("/var/www/2025-08-04_18_49/pages/information.vue")
  },
  {
    name: "order-light",
    path: "/order/light",
    component: () => import("/var/www/2025-08-04_18_49/pages/order/light.vue")
  },
  {
    name: "claim-filing",
    path: "/claim-filing",
    component: () => import("/var/www/2025-08-04_18_49/pages/claim-filing.vue")
  },
  {
    name: "gifts-type",
    path: "/gift/:type(m|o)",
    meta: _91type_930xtQljtbsMcT7zT9zMrfoth5_XPRpRksixUBY_tBsdgMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/gifts/[type].vue")
  },
  {
    name: "marketplaces",
    path: "/marketplaces",
    component: () => import("/var/www/2025-08-04_18_49/pages/marketplaces.vue")
  },
  {
    name: "networkshops",
    path: "/networkshops",
    component: () => import("/var/www/2025-08-04_18_49/pages/networkshops.vue")
  },
  {
    name: "online-store",
    path: "/online-store",
    component: () => import("/var/www/2025-08-04_18_49/pages/online-store.vue")
  },
  {
    name: "order-manage",
    path: "/order/manage",
    component: () => import("/var/www/2025-08-04_18_49/pages/order/manage.vue")
  },
  {
    name: "registration",
    path: "/registration",
    component: () => import("/var/www/2025-08-04_18_49/pages/registration.vue")
  },
  {
    name: "safe-custody",
    path: "/safe-custody",
    component: () => import("/var/www/2025-08-04_18_49/pages/safe-custody.vue")
  },
  {
    name: "ui-kit-image",
    path: "/ui-kit/image",
    component: () => import("/var/www/2025-08-04_18_49/pages/ui-kit/image.vue")
  },
  {
    name: "ui-kit",
    path: "/ui-kit",
    component: () => import("/var/www/2025-08-04_18_49/pages/ui-kit/index.vue")
  },
  {
    name: "wrapping-bag",
    path: "/wrapping/bag",
    component: () => import("/var/www/2025-08-04_18_49/pages/wrapping/bag.vue")
  },
  {
    name: "wrapping-box",
    path: "/wrapping/box",
    component: () => import("/var/www/2025-08-04_18_49/pages/wrapping/box.vue")
  },
  {
    name: "cargo-loading",
    path: "/cargo-loading",
    component: () => import("/var/www/2025-08-04_18_49/pages/cargo-loading.vue")
  },
  {
    name: "happybirthday",
    path: "/happybirthday",
    meta: happybirthdayJXd_1peOOcPc9MDERpkQunlRoIcWtAymFyAMb8Bx7OQMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/happybirthday.vue")
  },
  {
    name: "iframe-manage",
    path: "/iframe/manage",
    meta: managetZyEyBEF_45ZiwtRek0y2R_0d33BO_Eg76eMkQg2R6_fAMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/iframe/manage.vue")
  },
  {
    name: "personal-auth",
    path: "/personal/auth",
    component: () => import("/var/www/2025-08-04_18_49/pages/personal/auth.vue")
  },
  {
    name: "tariffs",
    path: "/tariffs",
    component: () => import("/var/www/2025-08-04_18_49/pages/tariffs/index.vue")
  },
  {
    name: "ui-kit-public",
    path: "/ui-kit/public",
    component: () => import("/var/www/2025-08-04_18_49/pages/ui-kit/public.vue")
  },
  {
    name: "already-answer",
    path: "/already-answer",
    component: () => import("/var/www/2025-08-04_18_49/pages/already-answer.vue")
  },
  {
    name: "iframe-tariffs",
    path: "/iframe/tariffs",
    meta: tariffsP4wgC4HlfwXXNuHwT1cjJvzAeH45ao3BngVVtrjHxVkMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/iframe/tariffs.vue")
  },
  {
    name: "order-pay-id",
    path: "/order/pay/:id()",
    component: () => import("/var/www/2025-08-04_18_49/pages/order/pay/[id].vue")
  },
  {
    name: "personal",
    path: "/personal",
    meta: indexPBKTqUhw2jJLM7zQYSEN18Jp0P_iPYPDGpKTcYtGXB4Meta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/personal/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/var/www/2025-08-04_18_49/pages/privacy-policy.vue")
  },
  {
    name: "welcome-hash",
    path: "/welcome/:hash()",
    component: () => import("/var/www/2025-08-04_18_49/pages/welcome/[hash].vue")
  },
  {
    name: "wrapping",
    path: "/wrapping",
    component: () => import("/var/www/2025-08-04_18_49/pages/wrapping/index.vue")
  },
  {
    name: "delivery-russia",
    path: "/delivery-russia",
    component: () => import("/var/www/2025-08-04_18_49/pages/delivery-russia.vue")
  },
  {
    name: "payment-methods",
    path: "/payment-methods",
    component: () => import("/var/www/2025-08-04_18_49/pages/payment-methods.vue")
  },
  {
    name: "payment-qr-info",
    path: "/payment/qr-info",
    component: () => import("/var/www/2025-08-04_18_49/pages/payment/qr-info.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    component: () => import("/var/www/2025-08-04_18_49/pages/payment/success.vue")
  },
  {
    name: "personal-import",
    path: "/personal/import",
    meta: importIoEgEqUjOJh3dJ16J8qoKMQ_LVaRpvSGsIeohkwQRE8Meta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/personal/import.vue")
  },
  {
    name: "personal-logout",
    path: "/personal/logout",
    meta: logoutJ45kdziRFuwOs2H_EytKW9MW374TT4plU7boUMdq9rYMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/personal/logout.vue")
  },
  {
    name: "address-delivery",
    path: "/address-delivery",
    component: () => import("/var/www/2025-08-04_18_49/pages/address-delivery.vue")
  },
  {
    name: "cash-on-delivery",
    path: "/cash-on-delivery",
    component: () => import("/var/www/2025-08-04_18_49/pages/cash-on-delivery.vue")
  },
  {
    name: "happynewyear2024",
    path: "/happynewyear2024",
    meta: happynewyear20244tiVii0p4Vza_UPB3Te6A4a_45dSLKsZ3RPskuAHtF280Meta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/happynewyear2024.vue")
  },
  {
    name: "marketplace-ozon",
    path: "/ozon",
    meta: ozon34wCH5aPOCGPxEl5eLMXaa_zsdcXz1s_45UgdCAFKZVHsMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/marketplace/ozon.vue")
  },
  {
    name: "payment-pay-fail",
    path: "/payment/pay-fail",
    component: () => import("/var/www/2025-08-04_18_49/pages/payment/pay-fail.vue")
  },
  {
    name: "personal-account",
    path: "/personal/account",
    meta: account6hBGDuYUod0hKqFLEMpmWimn_45_6UPYmAVIO4aV8jlwsMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/personal/account.vue")
  },
  {
    name: "prohibited-goods",
    path: "/prohibited-goods",
    component: () => import("/var/www/2025-08-04_18_49/pages/prohibited-goods.vue")
  },
  {
    name: "survey-completed",
    path: "/survey-completed",
    meta: survey_45completedwaqTOlVXN5FwWnbboBJQtdy_hOz3zxMRLXIr6gS2gW0Meta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/survey-completed.vue")
  },
  {
    name: "ui-kit-direction",
    path: "/ui-kit/direction",
    component: () => import("/var/www/2025-08-04_18_49/pages/ui-kit/direction.vue")
  },
  {
    name: "free-group-pickup",
    path: "/free-group-pickup",
    component: () => import("/var/www/2025-08-04_18_49/pages/free-group-pickup.vue")
  },
  {
    name: "free-pickup-cargo",
    path: "/free-pickup-cargo",
    component: () => import("/var/www/2025-08-04_18_49/pages/free-pickup-cargo.vue")
  },
  {
    name: "iframe-calculator",
    path: "/iframe/calculator",
    meta: calculatorlOxoAWjoCazhjiQOjehQeUY1R5yRR2VQ6_QHF0pOTEwMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/iframe/calculator.vue")
  },
  {
    name: "merch-for-bonuses",
    path: "/merch-for-bonuses",
    component: () => import("/var/www/2025-08-04_18_49/pages/merch-for-bonuses.vue")
  },
  {
    name: "order-pay-qr-id",
    path: "/order/pay/qr/:id()",
    component: () => import("/var/www/2025-08-04_18_49/pages/order/pay/qr/[id].vue")
  },
  {
    name: "payment-card-info",
    path: "/payment/card-info",
    component: () => import("/var/www/2025-08-04_18_49/pages/payment/card-info.vue")
  },
  {
    name: "personal-discount",
    path: "/personal/discount",
    meta: discountzslw_ALjsqNYaG1Uw6IxlQpz5Y__45hXXLLQFiEcLpmP0Meta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/personal/discount.vue")
  },
  {
    name: "wrapping-hard-box",
    path: "/wrapping/hard-box",
    component: () => import("/var/www/2025-08-04_18_49/pages/wrapping/hard-box.vue")
  },
  {
    name: "forwarding-receipt",
    path: "/forwarding-receipt",
    component: () => import("/var/www/2025-08-04_18_49/pages/forwarding-receipt.vue")
  },
  {
    name: "mailClient10201917",
    path: "/mailClient10201917",
    meta: mailClient10201917Z1rpNYOtV_45XPGyQEjHs3JSfV4gvPGvTeFDCP6pUGhP0Meta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/mailClient10201917.vue")
  },
  {
    name: "mobile-application",
    path: "/mobile-application",
    component: () => import("/var/www/2025-08-04_18_49/pages/mobile-application.vue")
  },
  {
    name: "order-create",
    path: "/order/create",
    meta: indexnwBVvCGRsOT8miTMA52E1fd1chCYpyzv18El_xNuB68Meta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/order/create/index.vue")
  },
  {
    name: "run-schedule",
    path: "/run-schedule",
    component: () => import("/var/www/2025-08-04_18_49/pages/run-schedule/index.vue")
  },
  {
    name: "shippingtypes-boat",
    path: "/shippingtypes/boat",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/boat.vue")
  },
  {
    name: "shippingtypes-sofa",
    path: "/shippingtypes/sofa",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/sofa.vue")
  },
  {
    name: "tariffs-location",
    path: "/tariffs/:location()",
    component: () => import("/var/www/2025-08-04_18_49/pages/tariffs/[location].vue")
  },
  {
    name: "wrapping-cardboard",
    path: "/wrapping/cardboard",
    component: () => import("/var/www/2025-08-04_18_49/pages/wrapping/cardboard.vue")
  },
  {
    name: "personal-promocodes",
    path: "/personal/promocodes",
    meta: promocodesTy1wvXU72CFquGHox_45lb25jzf5GBOgu05mcPQLMAHvcMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/personal/promocodes.vue")
  },
  {
    name: "shippingtypes-bench",
    path: "/shippingtypes/bench",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/bench.vue")
  },
  {
    name: "shippingtypes-books",
    path: "/shippingtypes/books",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/books.vue")
  },
  {
    name: "shippingtypes-cable",
    path: "/shippingtypes/cable",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/cable.vue")
  },
  {
    name: "shippingtypes-chair",
    path: "/shippingtypes/chair",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/chair.vue")
  },
  {
    name: "shippingtypes-goods",
    path: "/shippingtypes/goods",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/goods.vue")
  },
  {
    name: "shippingtypes",
    path: "/shippingtypes",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/index.vue")
  },
  {
    name: "shippingtypes-metal",
    path: "/shippingtypes/metal",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/metal.vue")
  },
  {
    name: "shippingtypes-piano",
    path: "/shippingtypes/piano",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/piano.vue")
  },
  {
    name: "shippingtypes-pipes",
    path: "/shippingtypes/pipes",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/pipes.vue")
  },
  {
    name: "shippingtypes-tools",
    path: "/shippingtypes/tools",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/tools.vue")
  },
  {
    name: "wrapping-pallet-box",
    path: "/wrapping/pallet-box",
    component: () => import("/var/www/2025-08-04_18_49/pages/wrapping/pallet-box.vue")
  },
  {
    name: "personal-bonus-tab",
    path: "/personal/bonus/:tab()",
    meta: _91tab_93PIWkw9T34NScKrOs3z0PhWVrkpCTa0gygsAczE7J1qAMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/personal/bonus/[tab].vue")
  },
  {
    name: "personal-order-print",
    path: "/personal/order/print",
    meta: printYUtv9ZM_x1zf3KMpNjQiDilxMjHMQP2r_Y1BF0NxqHQMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/personal/order/print.vue")
  },
  {
    name: "shippingtypes-dishes",
    path: "/shippingtypes/dishes",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/dishes.vue")
  },
  {
    name: "shippingtypes-engine",
    path: "/shippingtypes/engine",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/engine.vue")
  },
  {
    name: "shippingtypes-lumber",
    path: "/shippingtypes/lumber",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/lumber.vue")
  },
  {
    name: "shippingtypes-wheels",
    path: "/shippingtypes/wheels",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/wheels.vue")
  },
  {
    name: "wrapping-bubble-film",
    path: "/wrapping/bubble-film",
    component: () => import("/var/www/2025-08-04_18_49/pages/wrapping/bubble-film.vue")
  },
  {
    name: "wrapping-palletising",
    path: "/wrapping/palletising",
    component: () => import("/var/www/2025-08-04_18_49/pages/wrapping/palletising.vue")
  },
  {
    name: "fast-delivery-capital",
    path: "/fast-delivery-capital",
    component: () => import("/var/www/2025-08-04_18_49/pages/fast-delivery-capital.vue")
  },
  {
    name: "personal-order-guid",
    path: "/personal/order/:tag(pay)?/:guid",
    meta: _91guid_93z2u3XyVuUh066MUHOwU3EpLlXiCHVdoSdaxn6Pi0F_UMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/personal/order/[guid].vue")
  },
  {
    name: "personal-order-create",
    path: "/personal/order/create",
    meta: create0nfZLrij3IhGjRqk1QWSckwYz2G_45iuyZDqHRrQIIXA8Meta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/personal/order/create.vue")
  },
  {
    name: "shippingtypes-barrels",
    path: "/shippingtypes/barrels",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/barrels.vue")
  },
  {
    name: "shippingtypes-clothes",
    path: "/shippingtypes/clothes",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/clothes.vue")
  },
  {
    name: "shippingtypes-fragile",
    path: "/shippingtypes/fragile",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/fragile.vue")
  },
  {
    name: "shippingtypes-trailer",
    path: "/shippingtypes/trailer",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/trailer.vue")
  },
  {
    name: "wrapping-safe-package",
    path: "/wrapping/safe-package",
    component: () => import("/var/www/2025-08-04_18_49/pages/wrapping/safe-package.vue")
  },
  {
    name: "payment-bepaid-success",
    path: "/payment/bepaid-success",
    component: () => import("/var/www/2025-08-04_18_49/pages/payment/bepaid-success.vue")
  },
  {
    name: "wrapping-extra-package",
    path: "/wrapping/extra-package",
    component: () => import("/var/www/2025-08-04_18_49/pages/wrapping/extra-package.vue")
  },
  {
    name: "marketplace-wildberries",
    path: "/wildberries",
    meta: wildberriesgKy9_z9dhLcnAkqfKIBYzCAsDE8EgnbB6Cm3ccVnb0sMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/marketplace/wildberries.vue")
  },
  {
    name: "order-administer-guid",
    path: "/order/administer/:guid()",
    component: () => import("/var/www/2025-08-04_18_49/pages/order/administer/[guid].vue")
  },
  {
    name: "run-schedule-location",
    path: "/run-schedule/:location()",
    component: () => import("/var/www/2025-08-04_18_49/pages/run-schedule/[location].vue")
  },
  {
    name: "shippingtypes-furniture",
    path: "/shippingtypes/furniture",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/furniture.vue")
  },
  {
    name: "shippingtypes-oversized",
    path: "/shippingtypes/oversized",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/oversized.vue")
  },
  {
    name: "shippingtypes-quad-bike",
    path: "/shippingtypes/quad-bike",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/quad-bike.vue")
  },
  {
    name: "order-create-locations",
    path: "/order/create/:locations()",
    component: () => import("/var/www/2025-08-04_18_49/pages/order/create/[locations].vue")
  },
  {
    name: "personal-orders-tab",
    path: "/personal/orders/:tab(.*)*",
    meta: _91_46_46_46tab_93v1w_eU7fcdMrCs_45G66h5qE6QxBENVvBSPZDCZF1WP4cMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/personal/orders/[...tab].vue")
  },
  {
    name: "shippingtypes-auto-parts",
    path: "/shippingtypes/auto-parts",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/auto-parts.vue")
  },
  {
    name: "shippingtypes-newspapers",
    path: "/shippingtypes/newspapers",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/newspapers.vue")
  },
  {
    name: "shippingtypes-smallcargo",
    path: "/shippingtypes/smallcargo",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/smallcargo.vue")
  },
  {
    name: "shippingtypes-snowmobile",
    path: "/shippingtypes/snowmobile",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/snowmobile.vue")
  },
  {
    name: "iframe-order-create",
    path: "/iframe/order/create",
    meta: indextlFBoM1mAeV654hOXzjeWwt_45jZmwy9MLv8HoMOyIfewMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/iframe/order/create/index.vue")
  },
  {
    name: "marketplace-yandex-market",
    path: "/yandex-market",
    meta: yandex_45marketqjJrxNz95VmIBO_455Bl5JnyVIb8NNqcZ7J4wSi9mHPhAMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/marketplace/yandex-market.vue")
  },
  {
    name: "personal-orders-templates",
    path: "/personal/orders/templates",
    meta: templatessM7VSRrhl_45H3Wbwh_Bx9mtguRxHRnszOneFsHnWrtbgMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/personal/orders/templates.vue")
  },
  {
    name: "personal-contractors",
    path: "/personal/contractors",
    meta: indexj1PgZIlM9x4gS_45APqjfYerLHexza80Jz0uQEbwKS2XoMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/personal/contractors/index.vue")
  },
  {
    name: "shippingtypes-refrigerator",
    path: "/shippingtypes/refrigerator",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/refrigerator.vue")
  },
  {
    name: "personal-contractors-guid",
    path: "/personal/contractors/:guid()",
    meta: _91guid_93COI6M_wW_45YmDTc1Ca2PrrBfaa3FXirJaQnVPOA_45yjKYMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/personal/contractors/[guid].vue")
  },
  {
    name: "personal-multi-pickup",
    path: "/personal/multi-pickup",
    meta: indexaQd1XOawRHcVFm8iZL0RWDGPo1PPYY4zc6cIGYErxuUMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/personal/multi-pickup/index.vue")
  },
  {
    name: "personal-multi-pickup-guid",
    path: "/personal/multi-pickup/:guid",
    meta: _91guid_93jAonfxUPYkxRCSagoRzng8WyYBwHMbHb5_45OXHD3SOH8Meta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/personal/multi-pickup/[guid].vue")
  },
  {
    name: "shippingtypes-consumer-goods",
    path: "/shippingtypes/consumer-goods",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/consumer-goods.vue")
  },
  {
    name: "personal-group-printing",
    path: "/personal/group-printing",
    meta: indexSLqq_aw_LjOHKpwn47g6wt1gnDi3uWpXjynShKHqXHMMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/personal/group-printing/index.vue")
  },
  {
    name: "personal-multi-delivery",
    path: "/personal/multi-delivery",
    meta: indexeDFuiv_GVlvuRQ9CQR8_EE2Bx_45WvYWkHWHjjlrGtQfsMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/personal/multi-delivery/index.vue")
  },
  {
    name: "shippingtypes-medical-devices",
    path: "/shippingtypes/medical-devices",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/medical-devices.vue")
  },
  {
    name: "iframe-order-administer-guid",
    path: "/iframe/order/administer/:guid()",
    meta: _91guid_932vUM7PTNTQ7o6agkywVLA5f_459RmSuDZYr8PLvzkeK5QMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/iframe/order/administer/[guid].vue")
  },
  {
    name: "personal-multi-delivery-guid",
    path: "/personal/multi-delivery/:guid",
    meta: _91guid_93pEiX4dsoeZmw1UW5dSn4t7Qr7U_45EvV9k86yb13gFgFwMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/personal/multi-delivery/[guid].vue")
  },
  {
    name: "personal-order-template-id",
    path: "/personal/order/template/:id(.*)*",
    meta: _91_46_46_46id_93Fj0B0mh0RR1SbRpku_7VtuNjqMZygwOl3cbr0nf4VxIMeta || {},
    component: () => import("/var/www/2025-08-04_18_49/pages/personal/order/template/[...id].vue")
  },
  {
    name: "shippingtypes-special-equipment",
    path: "/shippingtypes/special-equipment",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/special-equipment.vue")
  },
  {
    name: "shippingtypes-building-materials",
    path: "/shippingtypes/building-materials",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/building-materials.vue")
  },
  {
    name: "shippingtypes-musical-instruments",
    path: "/shippingtypes/musical-instruments",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/musical-instruments.vue")
  },
  {
    name: "shippingtypes-industrial-equipment",
    path: "/shippingtypes/industrial-equipment",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/industrial-equipment.vue")
  },
  {
    name: "shippingtypes-motorcycletransportation",
    path: "/shippingtypes/motorcycletransportation",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/motorcycletransportation.vue")
  },
  {
    name: "order-create-locationFrom_locationTo",
    path: "/order/create/:locationFrom()_:locationTo()",
    component: () => import("/var/www/2025-08-04_18_49/pages/order/create/[locationFrom]_[locationTo].vue")
  },
  {
    name: "shippingtypes-personalitemstransportation",
    path: "/shippingtypes/personalitemstransportation",
    component: () => import("/var/www/2025-08-04_18_49/pages/shippingtypes/personalitemstransportation.vue")
  }
]